export const trackEvent = (eventName: string, key?: string): void => {
    (window as any).dataLayer?.push({ event: eventName, key });
};
